import location from '../../assets/images/contact/location.png';

export const web = [
	
	{ 
		name: 'Location', 
		date: '2022-03-20', 
		cover: location, 
		links: [
		],
	},
];
